export default "__VITE_ASSET__DhvtXlj9__"